// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pipeline {
  background-color: rgba(144, 110, 103, 0.7);
  width: 100%;
  padding: 200px 0 200px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
}

.pipeline__all-container {
  max-width: 1386px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.pipeline__header-container {
  display: flex;
  margin: 0 0 80px 0;
}

.pipeline__header {
  margin: 0 268px 0 0;
  padding: 0;
  font-family: "Playfair Display";
  font-size: 60px;
  font-weight: 500;
  line-height: 50px;
}

.pipeline__header-line {
  width: 450px;
  height: 1px;
  background-color: white;
  margin: 35px 0 0 0;
}

.pipeline__container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  column-gap: 35px;
  row-gap: 98px;
}

.pipeline__container-item {
  display: flex;
  width: 100%;
  text-wrap: wrap;
}

.pipeline__bubble {
  display: flex;
  width: 120px;
  height: 120px;
  font-family: "Playfair Display";
  font-weight: 600;
  line-height: 34px;
  font-size: 24px;
  border: 1px solid white;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin: 0 5px 0 0;
  padding: 0;
}

.pipeline__item-info {
  display: flex;
  flex-direction: column;
}

.pipeline__stage {
  font-family: "Playfair Display";
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  margin: 9px 0 0 0;
  padding: 0;
}

.pipeline__description {
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  max-width: 490px;
  margin: 17px 0 0 0;
}

@media screen and (max-width: 1439px) {
  .pipeline {
    padding: 100px 0 100px 0;
  }

  .pipeline__all-container {
    max-width: 984px;
    align-items: center;
  }
  
  .pipeline__header-container {
    margin: 0 0 40px 0;
  }

  .pipeline__header {
    margin: 0 63px 0 0;
    font-size: 45px;
    line-height: 55px;
  }

  .pipeline__header-line {
    width: 289px;
    margin: 35px 0 0 0;
  }

  .pipeline__container {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(4, 1fr);
    row-gap: 42px;
  }
}

@media screen and (max-width: 1023px) {
  .pipeline {
    padding: 75px 0 75px 0;
  }

  .pipeline__all-container {
    max-width: 708px;
  }

  .pipeline__header-container {
    margin: 0 0 35px 0;
  }

  .pipeline__header {
    margin: 0 40px 0 0;
    font-size: 35px;
    line-height: 45px;
  }

  .pipeline__header-line {
    margin: 25px 0 0 0;
  }

  .pipeline__stage {
    font-size: 20px;
    line-height: 30px;
  }

  .pipeline__description {
    font-size: 16px;
    line-height: 24px;
  }
}

@media screen and (max-width: 763px) {
  .pipeline {
    padding: 86px 0 86px 0;
  }

  .pipeline__all-container {
    max-width: 322px;
  }

  .pipeline__header-container {
    margin: 0 0 30px 0;
  }

  .pipeline__header {
    margin: 0 13px 0 0;
    font-size: 26px;
    line-height: 36px;
  }

  .pipeline__header-line {
    width: 112px;
    margin: 18px 0 0 0;
  }

  .pipeline__container {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(4, fit-content);
    column-gap: 0px;
    row-gap: 35px;
  }

  .pipeline__container-item {
    align-items: center;
  }

  .pipeline__bubble {
    font-size: 20px;
    line-height: 28px;
    width: 70px;
    height: 70px;
    margin: 0 8px 0 0;
  }

  .pipeline__stage {
    max-width: 230px;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }

  .pipeline__description {
    font-size: 16px;
    line-height: 24px;
    max-width: 220px;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pipeline/Pipeline.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,kCAAkC;IAClC,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,0CAA0C;IAC1C,eAAe;IACf,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".pipeline {\r\n  background-color: rgba(144, 110, 103, 0.7);\r\n  width: 100%;\r\n  padding: 200px 0 200px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto 0 auto;\r\n}\r\n\r\n.pipeline__all-container {\r\n  max-width: 1386px;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto;\r\n}\r\n\r\n.pipeline__header-container {\r\n  display: flex;\r\n  margin: 0 0 80px 0;\r\n}\r\n\r\n.pipeline__header {\r\n  margin: 0 268px 0 0;\r\n  padding: 0;\r\n  font-family: \"Playfair Display\";\r\n  font-size: 60px;\r\n  font-weight: 500;\r\n  line-height: 50px;\r\n}\r\n\r\n.pipeline__header-line {\r\n  width: 450px;\r\n  height: 1px;\r\n  background-color: white;\r\n  margin: 35px 0 0 0;\r\n}\r\n\r\n.pipeline__container {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-template-rows: repeat(2, 1fr);\r\n  column-gap: 35px;\r\n  row-gap: 98px;\r\n}\r\n\r\n.pipeline__container-item {\r\n  display: flex;\r\n  width: 100%;\r\n  text-wrap: wrap;\r\n}\r\n\r\n.pipeline__bubble {\r\n  display: flex;\r\n  width: 120px;\r\n  height: 120px;\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 600;\r\n  line-height: 34px;\r\n  font-size: 24px;\r\n  border: 1px solid white;\r\n  border-radius: 50%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 5px 0 0;\r\n  padding: 0;\r\n}\r\n\r\n.pipeline__item-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pipeline__stage {\r\n  font-family: \"Playfair Display\";\r\n  font-size: 24px;\r\n  font-weight: 400;\r\n  line-height: 34px;\r\n  margin: 9px 0 0 0;\r\n  padding: 0;\r\n}\r\n\r\n.pipeline__description {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  line-height: 26px;\r\n  max-width: 490px;\r\n  margin: 17px 0 0 0;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .pipeline {\r\n    padding: 100px 0 100px 0;\r\n  }\r\n\r\n  .pipeline__all-container {\r\n    max-width: 984px;\r\n    align-items: center;\r\n  }\r\n  \r\n  .pipeline__header-container {\r\n    margin: 0 0 40px 0;\r\n  }\r\n\r\n  .pipeline__header {\r\n    margin: 0 63px 0 0;\r\n    font-size: 45px;\r\n    line-height: 55px;\r\n  }\r\n\r\n  .pipeline__header-line {\r\n    width: 289px;\r\n    margin: 35px 0 0 0;\r\n  }\r\n\r\n  .pipeline__container {\r\n    grid-template-columns: repeat(1, 1fr);\r\n    grid-template-rows: repeat(4, 1fr);\r\n    row-gap: 42px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .pipeline {\r\n    padding: 75px 0 75px 0;\r\n  }\r\n\r\n  .pipeline__all-container {\r\n    max-width: 708px;\r\n  }\r\n\r\n  .pipeline__header-container {\r\n    margin: 0 0 35px 0;\r\n  }\r\n\r\n  .pipeline__header {\r\n    margin: 0 40px 0 0;\r\n    font-size: 35px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .pipeline__header-line {\r\n    margin: 25px 0 0 0;\r\n  }\r\n\r\n  .pipeline__stage {\r\n    font-size: 20px;\r\n    line-height: 30px;\r\n  }\r\n\r\n  .pipeline__description {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .pipeline {\r\n    padding: 86px 0 86px 0;\r\n  }\r\n\r\n  .pipeline__all-container {\r\n    max-width: 322px;\r\n  }\r\n\r\n  .pipeline__header-container {\r\n    margin: 0 0 30px 0;\r\n  }\r\n\r\n  .pipeline__header {\r\n    margin: 0 13px 0 0;\r\n    font-size: 26px;\r\n    line-height: 36px;\r\n  }\r\n\r\n  .pipeline__header-line {\r\n    width: 112px;\r\n    margin: 18px 0 0 0;\r\n  }\r\n\r\n  .pipeline__container {\r\n    grid-template-columns: repeat(1, 1fr);\r\n    grid-template-rows: repeat(4, fit-content);\r\n    column-gap: 0px;\r\n    row-gap: 35px;\r\n  }\r\n\r\n  .pipeline__container-item {\r\n    align-items: center;\r\n  }\r\n\r\n  .pipeline__bubble {\r\n    font-size: 20px;\r\n    line-height: 28px;\r\n    width: 70px;\r\n    height: 70px;\r\n    margin: 0 8px 0 0;\r\n  }\r\n\r\n  .pipeline__stage {\r\n    max-width: 230px;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    line-height: 28px;\r\n    margin: 0;\r\n  }\r\n\r\n  .pipeline__description {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    max-width: 220px;\r\n    margin: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
